import React, { PropsWithChildren } from 'react'

import Box from '@mui/material/Box'

import { useCopyStore } from './context/hooks'

interface MicroWidgetContainerProps {
  heightOverrides?: number | string
  widthOverrides?: number
}

const MicroWidgetContainer: React.FC<PropsWithChildren<MicroWidgetContainerProps>> = ({
  heightOverrides,
  widthOverrides,
  children,
}) => {
  const { carouselCopy: copy } = useCopyStore()

  return (
    <Box
      aria-label={copy?.carousel_title}
      aria-roledescription="carousel"
      role="group"
      sx={{
        boxSizing: 'border-box',
        height: !heightOverrides ? '100%' : undefined,
        m: '0 auto',
        width: !widthOverrides ? '100%' : undefined,
      }}
    >
      {children}
    </Box>
  )
}

export default MicroWidgetContainer
